<template>
  <div class="pd70">
    <div class="wrapper">
      <UiAnim type="lr-100">
        <UiZakazBtn />
      </UiAnim>
    </div>
  </div>
</template>
